export default __webpack_public_path__ + "static/media/ukri_logo.07843233.png";